// Montants disponibles : chacun correspond à un gabarit d'image côté functions
// (VALUE_TO_TEMPLATE). Ajouter une valeur ici sans ajouter le gabarit ferait
// échouer la génération.
export const GIFTCARD_VALUES = [60, 72, 78, 90] as const;

export type GiftcardValue = (typeof GIFTCARD_VALUES)[number];

export const PAYMENT_METHODS = [
  'cash',
  'card',
  'check',
  'transfer',
  'offert',
] as const;

export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  cash: 'Espèces',
  card: 'Carte bancaire (boutique)',
  check: 'Chèque',
  transfer: 'Virement',
  offert: 'Offert',
};

export interface ManualGiftcardInput {
  value: GiftcardValue;
  from: string;
  to: string;
  message?: string;
  email?: string;
  paymentMethod: PaymentMethod;
  note?: string;
  sendEmail?: boolean;
  /** Empêche la création d'un second bon si la requête est rejouée. */
  idempotencyKey?: string;
}

export interface GeneratedGiftcard {
  id: string;
  code: string;
  value: number;
  url: string | null;
  expiresAt: string | null;
  emailSent: boolean;
  alreadyExisted: boolean;
}

export interface GiftcardListItem {
  id: string;
  code: string;
  value: number;
  from: string;
  to: string;
  email: string | null;
  used: boolean;
  source: 'manual' | 'stripe';
  paymentMethod: string | null;
  imageUrl: string | null;
  createdAt: string | null;
  expiresAt: string | null;
  usedAt: string | null;
}
